<template>
  <div class="product-list-wrapper" v-if="series.length">
    <div id="seriesList" class="product-list">
      <SeriesCard
        v-for="(seriesObj) in series"
        :key="seriesObj.id"
        :series="seriesObj"
        :part-number-filter="partNumberFilter"
        @add-to-compare="addToCompare"
        @remove-from-compare="removeFromCompare"
      />
    </div>
    <div class="load-more-trigger" v-observe-visibility="loadMore"></div>
  </div>
  <div v-else class="no-models">We do not have any standard configurations with the requirements you selected at this time. Please either modify your selections to see our standard products, or <a href="/products/unique-ideas">contact Factory to discuss a Custom Solution!</a></div>
</template>

<script>
import SeriesCard from '@/components/SeriesCard.vue'

export default {
  name: 'SeriesSearchResults',
  components: {
    SeriesCard
  },
  props: {
    series: Array,
    partNumberFilter: String
  },
  emits: ['loadMore'],
  methods: {
    loadMore: function (isVisible) {
      if (isVisible) {
        this.$emit('loadMore')
      }
    },
    addToCompare: function (seriesId) {
      this.$emit('addToCompare', seriesId)
    },
    removeFromCompare: function (seriesId) {
      this.$emit('removeFromCompare', seriesId)
    }
  }
}
</script>
